// src/Perforation.ts
var perforationTypes = [
  "Imperforated",
  "Line",
  "Comb",
  "Diecutting"
  /* Stanzung */
];
var PerforationValueFractional = /* @__PURE__ */ ((PerforationValueFractional2) => {
  PerforationValueFractional2[PerforationValueFractional2["quarter"] = 0] = "quarter";
  PerforationValueFractional2[PerforationValueFractional2["half"] = 1] = "half";
  PerforationValueFractional2[PerforationValueFractional2["three_quarters"] = 2] = "three_quarters";
  return PerforationValueFractional2;
})(PerforationValueFractional || {});
var securityHoleShapes = ["Round", "Ellipse", "Cross", "Star", "Rhombus", "Motif"];
var securityHoleScopes = ["AllFour", "HorizontalOnly", "VerticalOnly"];
var securityHolePositions = ["Center", "Nth"];
var securityHoleOrientations = ["ParallelToRow", "PerpendicularToRow"];
function supportsSecurityPerforation(type) {
  return type === "Line" || type === "Comb";
}
function dimensionKindForShape(shape) {
  switch (shape) {
    case "Round":
      return "Round";
    case "Ellipse":
      return "Elliptic";
    default:
      return "Polygonal";
  }
}
function securityHoleUsesOrientation(shape) {
  return shape === "Ellipse";
}
function securityHoleUsesPoints(shape) {
  return shape === "Star";
}
function emptyDimensionsForShape(shape) {
  switch (dimensionKindForShape(shape)) {
    case "Round":
      return { kind: "Round", diameter: 0 };
    case "Elliptic":
      return { kind: "Elliptic", majorAxis: 0, minorAxis: 0 };
    case "Polygonal":
      return securityHoleUsesPoints(shape) ? { kind: "Polygonal", circumradius: 0, inradius: 0, points: 6 } : { kind: "Polygonal", circumradius: 0, inradius: 0 };
  }
}
function defaultSecurityPerforation() {
  return { shape: "Ellipse", holesPerSide: 1, scope: "AllFour", position: "Center", orientation: "ParallelToRow" };
}
function withSecurityHoleShape(security, shape) {
  var _a, _b, _c;
  const next = { ...security, shape };
  if (shape !== "Motif") delete next.shapeText;
  if (securityHoleUsesOrientation(shape)) next.orientation = (_a = security.orientation) != null ? _a : "ParallelToRow";
  else delete next.orientation;
  if (next.dimensions && next.dimensions.kind !== dimensionKindForShape(shape)) {
    next.dimensions = emptyDimensionsForShape(shape);
  } else if (((_b = next.dimensions) == null ? void 0 : _b.kind) === "Polygonal") {
    if (securityHoleUsesPoints(shape)) {
      next.dimensions = { ...next.dimensions, points: (_c = next.dimensions.points) != null ? _c : 6 };
    } else {
      const { points, ...rest } = next.dimensions;
      next.dimensions = rest;
    }
  }
  return next;
}
function isPositiveInt(v) {
  return v !== void 0 && Number.isInteger(v) && v > 0;
}
function isPositiveNumber(v) {
  return v !== void 0 && Number.isFinite(v) && v > 0;
}
function validateSecurityPerforation(security) {
  var _a;
  if (!securityHoleShapes.includes(security.shape)) {
    return [false, "validation.securityHoleShapeNotSet"];
  }
  if (security.shape === "Motif" && !((_a = security.shapeText) == null ? void 0 : _a.trim())) {
    return [false, "validation.securityHoleShapeTextMissing"];
  }
  if (!isPositiveInt(security.holesPerSide)) {
    return [false, "validation.securityHoleCountInvalid"];
  }
  if (!securityHoleScopes.includes(security.scope)) {
    return [false, "validation.securityHoleScopeNotSet"];
  }
  if (security.position === "Nth" && !isPositiveInt(security.positionIndex)) {
    return [false, "validation.securityHolePositionIndexInvalid"];
  }
  if (securityHoleUsesOrientation(security.shape) && !security.orientation) {
    return [false, "validation.securityHoleOrientationNotSet"];
  }
  const d = security.dimensions;
  if (!d) return [true, ""];
  if (d.kind !== dimensionKindForShape(security.shape)) {
    return [false, "validation.securityHoleDimensionsMismatch"];
  }
  switch (d.kind) {
    case "Round":
      if (!isPositiveNumber(d.diameter)) return [false, "validation.securityHoleDimensionsIncomplete"];
      break;
    case "Elliptic":
      if (!isPositiveNumber(d.majorAxis) || !isPositiveNumber(d.minorAxis)) {
        return [false, "validation.securityHoleDimensionsIncomplete"];
      }
      if (d.minorAxis > d.majorAxis) return [false, "validation.securityHoleAxesSwapped"];
      break;
    case "Polygonal":
      if (!isPositiveNumber(d.circumradius) || !isPositiveNumber(d.inradius)) {
        return [false, "validation.securityHoleDimensionsIncomplete"];
      }
      if (d.inradius > d.circumradius) return [false, "validation.securityHoleRadiiSwapped"];
      if (securityHoleUsesPoints(security.shape) && d.points !== void 0 && (!isPositiveInt(d.points) || d.points < 3)) {
        return [false, "validation.securityHoleStarPointsInvalid"];
      }
      break;
  }
  return [true, ""];
}

// src/PhilatelicItem.ts
var gumTypes = ["none", "dull", "glossy", "adhesive"];
var CATALOG_NAMES = ["Michel", "Scott", "Yang", "Stanley_Gibbons", "Yvert_Tellier"];
var PhilatelicItemType = /* @__PURE__ */ ((PhilatelicItemType2) => {
  PhilatelicItemType2[PhilatelicItemType2["SingleStamp"] = 0] = "SingleStamp";
  PhilatelicItemType2[PhilatelicItemType2["Set"] = 1] = "Set";
  PhilatelicItemType2[PhilatelicItemType2["StampFromSet"] = 2] = "StampFromSet";
  PhilatelicItemType2[PhilatelicItemType2["Block"] = 3] = "Block";
  PhilatelicItemType2[PhilatelicItemType2["Booklet"] = 4] = "Booklet";
  PhilatelicItemType2[PhilatelicItemType2["SeTenants"] = 5] = "SeTenants";
  return PhilatelicItemType2;
})(PhilatelicItemType || {});
function isSuggestion(item) {
  return item.review.state === "Suggested";
}
function canReview(role) {
  return role === "Admin" || role === "Reviewer";
}
function canEdit(item, userId) {
  return item.review.suggestedBy === userId;
}

// src/Zhihao.ts
var ZHIHAO_EPOCH_RANGES = [
  { epoch: "Early", from: "1949-10-08", to: "1967-04-19" },
  { epoch: "Wen", from: "1967-04-20", to: "1970-08-31" },
  { epoch: "Numbered", from: "1970-09-01", to: "1973-12-31" },
  { epoch: "JT", from: "1974-01-01", to: "1991-12-31" },
  { epoch: "Biannian", from: "1992-01-01" }
];
var ZHIHAO_PREFIXES = [
  // 1949-1967
  { code: "\u7EAA", epoch: "Early", format: "EarlySeries", from: "1949-10-08", to: "1967-04-19", labelKey: "zhihao.prefixLabels.ji" },
  { code: "\u7279", epoch: "Early", format: "EarlySeries", from: "1951-10-01", to: "1966-05-31", labelKey: "zhihao.prefixLabels.te" },
  { code: "\u6539", epoch: "Early", format: "Plain", from: "1950-01-01", to: "1952-12-31", labelKey: "zhihao.prefixLabels.gai" },
  { code: "\u6B20", epoch: "Early", format: "Plain", from: "1950-01-01", to: "1954-12-31", labelKey: "zhihao.prefixLabels.qian" },
  { code: "\u519B", epoch: "Early", format: "Plain", from: "1953-08-01", to: "1953-12-31", labelKey: "zhihao.prefixLabels.jun" },
  { code: "\u822A", epoch: "Early", format: "Plain", from: "1951-05-01", to: "1957-12-31", labelKey: "zhihao.prefixLabels.hang" },
  // 1967-1970
  { code: "\u6587", epoch: "Wen", format: "ParenSeries", from: "1967-04-20", to: "1970-08-31", labelKey: "zhihao.prefixLabels.wen" },
  // 1970-1973
  { code: "\u7F16\u53F7", epoch: "Numbered", format: "Running", from: "1970-09-01", to: "1973-12-31", labelKey: "zhihao.prefixLabels.numbered" },
  // 1974-1991
  { code: "J", epoch: "JT", format: "DottedSeries", from: "1974-01-01", to: "1991-12-31", labelKey: "zhihao.prefixLabels.J" },
  { code: "T", epoch: "JT", format: "DottedSeries", from: "1974-01-01", to: "1991-12-31", labelKey: "zhihao.prefixLabels.T" },
  // since 1992
  { code: "J", epoch: "Biannian", format: "Year", from: "1992-01-01", labelKey: "zhihao.prefixLabels.J" },
  { code: "T", epoch: "Biannian", format: "Year", from: "1992-01-01", labelKey: "zhihao.prefixLabels.T" },
  { code: "\u7279", epoch: "Biannian", format: "Year", from: "1992-01-01", labelKey: "zhihao.prefixLabels.teSpecial" },
  { code: "\u8D3A", epoch: "Biannian", format: "Year", from: "2000-01-01", labelKey: "zhihao.prefixLabels.he" },
  { code: "\u4E2A", epoch: "Biannian", format: "Year", from: "2002-01-01", labelKey: "zhihao.prefixLabels.ge" },
  { code: "\u9644", epoch: "Biannian", format: "Year", from: "1992-01-01", labelKey: "zhihao.prefixLabels.fu" },
  // across all eras
  { code: "\u666E", epoch: "Universal", format: "Plain", from: "1950-02-01", labelKey: "zhihao.prefixLabels.pu" },
  { code: "SB", epoch: "Universal", format: "Booklet", from: "1980-01-01", labelKey: "zhihao.prefixLabels.SB" }
];
function zhihaoPrefixId(def) {
  return `${def.epoch}:${def.code}`;
}
function findZhihaoPrefix(code, epoch) {
  return ZHIHAO_PREFIXES.find((p) => p.code === code && p.epoch === epoch);
}
function toDay(value) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}
function coversDay(range, day) {
  if (day < range.from) return false;
  return range.to === void 0 || day <= range.to;
}
function epochForDate(date) {
  var _a, _b;
  if (!date) return null;
  const day = toDay(date);
  if (!day) return null;
  return (_b = (_a = ZHIHAO_EPOCH_RANGES.find((r) => coversDay(r, day))) == null ? void 0 : _a.epoch) != null ? _b : null;
}
function prefixesForDate(date) {
  const epoch = epochForDate(date);
  if (epoch === null) return { matching: ZHIHAO_PREFIXES.slice(), other: [] };
  const day = toDay(date);
  const matching = [];
  const other = [];
  for (const def of ZHIHAO_PREFIXES) {
    const fits = def.epoch === epoch || def.epoch === "Universal" && coversDay(def, day);
    (fits ? matching : other).push(def);
  }
  return { matching, other };
}
function zhihaoMatchesDate(zhihao, date) {
  const epoch = epochForDate(date);
  if (epoch === null) return true;
  return zhihao.epoch === epoch || zhihao.epoch === "Universal";
}
function zhihaoUsesSetNotation(format) {
  return format === "EarlySeries" || format === "ParenSeries" || format === "DottedSeries" || format === "Year";
}
function zhihaoUsesPosition(format) {
  return format !== "Running" && format !== "Booklet";
}
function setNotation(zhihao, open, close) {
  if (!zhihao.setSize || !zhihao.position) return "";
  return `${open}${zhihao.setSize}-${zhihao.position}${close}`;
}
function formatZhihao(zhihao) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const def = findZhihaoPrefix(zhihao.prefix, zhihao.epoch);
  const p = zhihao.prefix;
  if (!def) return (_a = zhihao.raw) != null ? _a : p;
  switch (def.format) {
    case "EarlySeries":
      return `${p}${(_b = zhihao.series) != null ? _b : ""}${setNotation(zhihao, ".", "")}`;
    case "ParenSeries":
      return `${p}${(_c = zhihao.series) != null ? _c : ""}${setNotation(zhihao, " (", ")")}`;
    case "DottedSeries":
      return `${p}.${(_d = zhihao.series) != null ? _d : ""}${setNotation(zhihao, " (", ")")}`;
    case "Running":
      return `${p}${(_e = zhihao.series) != null ? _e : ""}`;
    case "Year":
      return `${(_f = zhihao.year) != null ? _f : ""}-${(_g = zhihao.series) != null ? _g : ""}${setNotation(zhihao, " (", ")")} ${p}`;
    case "Plain":
      return `${p}${(_h = zhihao.series) != null ? _h : ""}${zhihao.position ? `-${zhihao.position}` : ""}`;
    case "Booklet":
      return `${p}(${(_i = zhihao.series) != null ? _i : ""})${zhihao.year ? ` ${zhihao.year}` : ""}`;
  }
}
function withZhihaoRaw(zhihao) {
  return { ...zhihao, raw: formatZhihao(zhihao) };
}
function withZhihaoDefaults(zhihao, defaults) {
  var _a, _b;
  const def = findZhihaoPrefix(zhihao.prefix, zhihao.epoch);
  if (!def || !zhihaoUsesSetNotation(def.format)) return withZhihaoRaw(zhihao);
  return withZhihaoRaw({
    ...zhihao,
    setSize: (_a = zhihao.setSize) != null ? _a : defaults.setSize,
    position: (_b = zhihao.position) != null ? _b : defaults.position
  });
}
function zhihaoForStampInSet(setZhihao, position) {
  if (!setZhihao) return void 0;
  return withZhihaoRaw({ ...setZhihao, position });
}
var num = (v) => v === void 0 ? void 0 : Number(v);
function parseZhihao(input) {
  const s = input.trim();
  if (!s) return null;
  let m;
  if (m = s.match(/^(\d{4})-(\d+)(?:\s*\((\d+)-(\d+)\))?\s*([A-Za-z一-鿿]+)$/)) {
    return withZhihaoRaw({ prefix: m[5], epoch: "Biannian", year: num(m[1]), series: num(m[2]), setSize: num(m[3]), position: num(m[4]) });
  }
  if (m = s.match(/^SB\s*\((\d+)\)\s*(\d{4})?$/)) {
    return withZhihaoRaw({ prefix: "SB", epoch: "Universal", series: num(m[1]), year: num(m[2]) });
  }
  if (m = s.match(/^([JT])\.\s*(\d+)(?:\s*\((\d+)-(\d+)\))?$/)) {
    return withZhihaoRaw({ prefix: m[1], epoch: "JT", series: num(m[2]), setSize: num(m[3]), position: num(m[4]) });
  }
  if (m = s.match(/^(文)(\d+)(?:\s*\((\d+)-(\d+)\))?$/)) {
    return withZhihaoRaw({ prefix: m[1], epoch: "Wen", series: num(m[2]), setSize: num(m[3]), position: num(m[4]) });
  }
  if (m = s.match(/^(?:编号|N)\s*(\d+)$/)) {
    return withZhihaoRaw({ prefix: "\u7F16\u53F7", epoch: "Numbered", series: num(m[1]) });
  }
  if (m = s.match(/^(纪|特)(\d+)(?:\.(\d+)-(\d+))?$/)) {
    return withZhihaoRaw({ prefix: m[1], epoch: "Early", series: num(m[2]), setSize: num(m[3]), position: num(m[4]) });
  }
  if (m = s.match(/^(普|改|欠|军|航)(\d+)(?:-(\d+))?$/)) {
    const prefix = m[1];
    return withZhihaoRaw({ prefix, epoch: prefix === "\u666E" ? "Universal" : "Early", series: num(m[2]), position: num(m[3]) });
  }
  return null;
}
function isPositiveInt2(v) {
  return v !== void 0 && Number.isInteger(v) && v > 0;
}
function validateZhihao(zhihao) {
  const def = findZhihaoPrefix(zhihao.prefix, zhihao.epoch);
  if (!def) return [false, "validation.zhihaoPrefixUnknown"];
  if (!isPositiveInt2(zhihao.series)) return [false, "validation.zhihaoIncomplete"];
  if (def.format === "Year" && !isPositiveInt2(zhihao.year)) return [false, "validation.zhihaoIncomplete"];
  if (zhihao.year !== void 0 && !isPositiveInt2(zhihao.year)) return [false, "validation.zhihaoIncomplete"];
  const hasSetSize = zhihao.setSize !== void 0;
  const hasPosition = zhihao.position !== void 0;
  if (!zhihaoUsesSetNotation(def.format)) {
    if (hasPosition && zhihaoUsesPosition(def.format) && !isPositiveInt2(zhihao.position)) {
      return [false, "validation.zhihaoIncomplete"];
    }
    return [true, ""];
  }
  if (hasPosition && !hasSetSize) return [false, "validation.zhihaoIncomplete"];
  if (hasSetSize && !isPositiveInt2(zhihao.setSize)) return [false, "validation.zhihaoIncomplete"];
  if (hasPosition && !isPositiveInt2(zhihao.position)) return [false, "validation.zhihaoIncomplete"];
  if (hasPosition && zhihao.position > zhihao.setSize) {
    return [false, "validation.zhihaoPositionExceedsSetSize"];
  }
  return [true, ""];
}

// src/FaceValue.ts
var monetaryUnits = ["Yuan", "Fen"];

// src/Misc.ts
var ItemType = /* @__PURE__ */ ((ItemType2) => {
  ItemType2[ItemType2["Item"] = 0] = "Item";
  ItemType2[ItemType2["Suggestion"] = 1] = "Suggestion";
  return ItemType2;
})(ItemType || {});
export {
  CATALOG_NAMES,
  ItemType,
  PerforationValueFractional,
  PhilatelicItemType,
  ZHIHAO_EPOCH_RANGES,
  ZHIHAO_PREFIXES,
  canEdit,
  canReview,
  defaultSecurityPerforation,
  dimensionKindForShape,
  emptyDimensionsForShape,
  epochForDate,
  findZhihaoPrefix,
  formatZhihao,
  gumTypes,
  isSuggestion,
  monetaryUnits,
  parseZhihao,
  perforationTypes,
  prefixesForDate,
  securityHoleOrientations,
  securityHolePositions,
  securityHoleScopes,
  securityHoleShapes,
  securityHoleUsesOrientation,
  securityHoleUsesPoints,
  supportsSecurityPerforation,
  validateSecurityPerforation,
  validateZhihao,
  withSecurityHoleShape,
  withZhihaoDefaults,
  withZhihaoRaw,
  zhihaoForStampInSet,
  zhihaoMatchesDate,
  zhihaoPrefixId,
  zhihaoUsesPosition,
  zhihaoUsesSetNotation
};
//# sourceMappingURL=index.js.map